module.exports = __webpack_public_path__ + "static/media/adh3.3fb58deb.jpg";